import { app } from '../app';

class AddNewApplicationResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getAllApplicationsTypes(companyId) {
        const url = `app/rest/admin/company/${companyId}/applications/types`;
        return this.$http.get(url).then(({data}) => data);
    }

    getApplicationsType(companyId, appTypeId) {
        const url = `app/rest/admin/company/${companyId}/applications/types/${appTypeId}`;
        return this.$http.get(url).then(({data}) => data);
    }

    getApplicationConfigParameters(companyId, appTypeId) {
        const url = `app/rest/admin/company/${companyId}/applications/types/${appTypeId}`;
        const params = {action: 'config'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    createNonDomainApp(companyId, applicationAndConfigDto) {
        const appTypeId = applicationAndConfigDto.applicationRequest.applicationType;
        const url = `app/rest/admin/company/${companyId}/applications/types/${appTypeId}`;
        return this.$http.post(url, applicationAndConfigDto).then(({data}) => data);
    }

    createSecureApp(companyId, appTypeId) {
        const url = `app/rest/admin/company/${companyId}/applications/types/${appTypeId}`;
        const params = {action: 'create'};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getAllApplicationInfoWithoutParameters(companyId, appTypeId) {
        const url = `app/rest/admin/company/${companyId}/applications/types/${appTypeId}`;
        const params = {action: 'info'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }
    
    getApplicationPermissionsInCompany(companyId) {
    	 const url = `app/rest/admin/company/${companyId}/applications/types/app-permissions`;
         return this.$http.get(url).then(({data}) => data);
    }
}

app.service('AddNewApplicationResource', AddNewApplicationResource);



// WEBPACK FOOTER //
// ./src/portal/services/add-new-application-resource.service.js